import styled, { css } from 'styled-components';
import { ScreenWrapper } from '@CS/app/App.styles';
import { BORDER_WIDTH } from '@CS/components/Wheel/Wheel.styles';

export const WheelScreen = styled(ScreenWrapper)`
  padding: 0 clamp(20px, 6.667vmin, 30px);

  > button {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const WheelContainer = styled.div`
  margin-bottom: 3rem;
  aspect-ratio: 1 / 1;
  perspective: 800px;
  position: relative;
  width: 100%;
`;

type ContentAttributes = {
  $back?: boolean;
  $flip: boolean;
};

export const FLIP_DURATION = 500;

export const WheelContent = styled.div<ContentAttributes>(
  ({ $flip, $back }) => css`
    --border-width: 2px;
    --border-padding: ${BORDER_WIDTH * 2}px;
    --box-shadow: 0 calc(var(--border-width) * 2) 0 0 rgb(34 34 34);

    transition: transform ${FLIP_DURATION}ms ease-in-out;
    transform: rotateY(${-$flip * 180}deg);

    backface-visibility: hidden;
    transform-origin: center;
    justify-content: center;

    align-items: center;
    border-radius: 50%;
    position: absolute;

    display: flex;
    height: 100%;
    width: 100%;

    ${$back &&
    css`
      border: ${BORDER_WIDTH}px solid rgb(187 187 187);
      transform: rotateY(${+!$flip * 180}deg);
      background-color: rgb(191 191 191);
    `}

    &::after,
    &::before {
      border: var(--border-width) solid rgb(0 0 0);
      box-shadow: var(--box-shadow);

      border-radius: 50%;
      position: absolute;

      height: 100%;
      width: 100%;
      content: '';
    }

    &::after {
      height: calc(100% - var(--border-padding));
      width: calc(100% - var(--border-padding));
      box-shadow: inset var(--box-shadow);

      ${$back &&
      css`
        height: 100%;
        width: 100%;
      `}
    }

    ${$back &&
    css`
      &::before {
        height: calc(100% + var(--border-padding));
        width: calc(100% + var(--border-padding));
      }
    `}
  `
);

export const Pointer = styled.img`
  top: ${BORDER_WIDTH}px;
  aspect-ratio: 47 / 45;
  position: absolute;
  width: 47px;
  z-index: 1;
`;

export const BackTitle = styled.h2`
  text-transform: uppercase;
  color: rgb(0 0 0);
`;
